import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { ReturnConfirmation } from "@redotech/redo-customer-portal-app/portal-four/returns/confirmation";
import { RouteObject } from "react-router-dom";
import { Page } from "../order/page";
export const returnRoutes: RouteObject[] = [
  {
    path: ":returnId/exchange-conversion",
    lazy: async () => {
      const { ExchangeConversionScreen } = await import(
        "@redotech/redo-customer-portal-app/portal-four/returns/exchange-conversion/exchange-conversion"
      );
      return {
        element: (
          <Page>
            <ExchangeConversionScreen />
          </Page>
        ),
      };
    },
  },
  {
    path: ":returnId/completeExchange",
    lazy: async () => {
      const { CompleteExchange } = await import("./complete-exchange");
      return { Component: CompleteExchange };
    },
  },
  {
    path: ":returnId",
    lazy: async () => {
      return {
        element: (
          <AuthGuard unauthorizedMessage="You need to login again to see this return confirmation.">
            <Page>
              <ReturnConfirmation />
            </Page>
          </AuthGuard>
        ),
      };
    },
  },
];
